class IntroductionPopupController {

  constructor($state, authService) {
    'ngInject';

    Object.assign(this, { $state, authService});
    this.user = authService.userData.firstName
  }

  $onInit() {
    $('body').css('overflow', 'hidden');
  }

  $onDestroy() {
    $('body').css('overflow', 'auto');
  }

  close() {
    this.onClose({$event: {name: 'introduction-popup'}})
  }
}

export default IntroductionPopupController;



// WEBPACK FOOTER //
// ./client/app/components/popups/dashboard/introduction-popup/introduction-popup.controller.js